import React from "react";
import PropTypes from "prop-types";
import { styled, Switch, FormControlLabel, Grid, Typography } from "@mui/material";

const IOSSwitch = styled(({ checked, ...props }) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" checked={checked} {...props} />
))(({ theme }) => ({
  width: 44,
  height: 20,
  padding: 0,
  "& .MuiButtonBase-root ": {
    position: "relative",
  },
  "& .MuiSwitch-switchBase": {
    padding: 0,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      color: "#fff",
      "& + .MuiSwitch-track": {
        background: "linear-gradient(54.23deg, #E8447D 1.96%, #FB83AC 99.68%)",
        opacity: 1,
        border: "none",
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 1,
      },
      "& .MuiSwitch-thumb": {
        transform: "translate(-10%,-50%) !important",
        boxShadow:
          "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: "#fff",
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 1,
    },
  },
  "& .MuiSwitch-thumb": {
    position: "absolute",
    top: "50%",
    left: 0,
    transform: "translate(15%,-50%)",
    boxSizing: "border-box",
    width: 23,
    height: 15,
    borderRadius: 26 / 2,
    boxShadow: "none",
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
function BaseSwitch({ label, checked, onChange = () => {}, disabled = false }) {
  return (
    <Grid
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      flexWrap="wrap-reverse"
      m={0}
    >
      <Typography variant="h2" textAlign="right" sx={{ direction: "rtl" }}>
        {label}
      </Typography>
      <FormControlLabel
        disabled={disabled}
        onChange={onChange}
        control={<IOSSwitch checked={checked} />}
        labelPlacement="start"
        sx={{ marginRight: 0 }}
      />
    </Grid>
  );
}

BaseSwitch.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

export default BaseSwitch;
